import { ContactPageOutlined } from '@mui/icons-material';
import { Widget, WidgetContent, WidgetHeader, WidgetIcon } from '@procureai/ui-mui';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';

import { SupplierContactForm } from './components/SupplierContactForm/SupplierContactForm';

export const NegotiationSupplierContactWidget = () => {
  const { t } = useTranslation(I18nNamespace.widgets, { keyPrefix: 'NegotiationSupplierContactWidget' });
  return (
    <>
      <Widget hover={false} data-intercom-target="NegotiationSupplierContactWidget">
        <WidgetHeader title={t('title')} icon={<WidgetIcon icon={<ContactPageOutlined fontSize="small" />} />} />
        <WidgetContent>
          <SupplierContactForm />
        </WidgetContent>
      </Widget>
    </>
  );
};
